import React, {Component} from "react";
import {Button, Layout, message, Progress, Select} from "antd";
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/chart/line';
import Header from "../../components/header";
import LeftAd from "../../components/leftAd"
import '../../assets/css/admin.less'
import {reqClassList, reqPaperList, reqPaperReport} from "../../api";
import './analysis.less'
import echarts from "echarts/lib/echarts";

const {Content} = Layout;
const {Option} = Select;

export class Analysis extends Component {

    state = {
        classList: [],
        classRoomId: '',
        totalAssign: 0,
        totalComplete: 0,
        totalParticipants:0,
        lowScore: 0,
        highScore: 0,
        historyGram: {},
        avgScore: 0,
        paperList: [],
        type: 0,
        testPaperId: 0,
        disabled:true,
        firstClassId:"",
        percent:0,
        paperName:""
    };

    getClassList = async (data) => {
        const result = await reqClassList(data);
        if (result.code === '000000') {
            this.setState({
                classList:result.data.rows
            });
            if(result.data.rows&&result.data.rows.length>0){
                this.getPaperReport({"classRoomId":result.data.rows[0].id,"type":"MOCK"});
                document.getElementsByClassName("ant-select-selection-selected-value")[1].innerHTML = result.data.rows[0].name;
                this.setState({
                    classRoomId:result.data.rows[0].id,
                    firstClassId:result.data.rows[0].id
                });
            }
        } else {
            message.error(result.msg);
        }
    };

    selectClass = e => {
        this.setState({
            classRoomId: e
        });
    };

    selectType = e => {
        if(e==="MOCK"){
            this.setState({
                type: e,
                disabled:true,
            });
        }else {
            this.setState({
                type: e,
                disabled:false,
            });
        }
    };

    selectPaper = e => {
        this.setState({
            testPaperId: e
        });
    };

    getChart = (data) => {
        // 基于准备好的dom，初始化echarts实例
        let myChart = echarts.init(document.getElementById('main'));
        let option = {
            grid: {
                show: true,
                borderColor: "transparent",
            },
            tooltip: {
                trigger: 'axis'
            },
            xAxis: [{
                axisLine: {
                    lineStyle: {
                        type: 'solid',
                        color: '#e6e6e6',//左边线的颜色
                        width: '2'//坐标线的宽度
                    }
                },
                axisLabel: {
                    textStyle: {
                        color: '#b4b4b4',
                        fontSize: '10'
                    }
                },
                axisTick: {
                    show: false
                },
                type: 'category',
                name: '正确率',
                nameTextStyle: {
                    color: '#b4b4b4',
                    padding: [0, 10, 0, -10]
                },
                data: ['50%以下', '50%-60%', '60%-70%', '70%-80%', '80%-90%', '90%以上']
            }],
            yAxis: [
                {
                    axisLine: {
                        lineStyle: {
                            type: 'solid',
                            color: '#e6e6e6',//左边线的颜色
                            width: '2'//坐标线的宽度
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: ['white'],
                            width: 2,
                            type: 'solid'
                        }
                    },
                    axisLabel: {
                        formatter: function () {
                            return "";
                        }
                    },
                    type: 'value',
                    name: '次数',
                    nameTextStyle: {
                        color: '#b4b4b4'
                    },
                }
            ],
            series: [
                {
                    data: data,
                    type: 'bar',
                    barWidth: 13,
                    itemStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: '#12c4ed'
                        }, {
                            offset: 1,
                            color: '#2f89ff'
                        }]),   //柱状颜色和圆角
                        barBorderRadius: [5, 5, 0, 0], // （顺时针左上，右上，右下，左下）
                        normal: {
                            borderWidth: 3,//拐点边框大小
                            barBorderRadius: [5, 5, 0, 0],
                            borderColor: '#B3E6F9',
                            label: {
                                show: true,		//开启显示
                                position: 'top',	//在上方显示
                                textStyle: {	    //数值样式
                                    color: '#1ed5ff'
                                },
                                formatter: '{c}次',
                            }
                        },
                    }
                }
            ],
            color: ['#12c4ed', '#FC896C']
        };
        // 绘制图表
        myChart.setOption(option);
    };

    getPaperReport = async (data) => {
        if(data.type==="FORMAL"){
            if(data.testPaperId){
                const result = await reqPaperReport(data);
                let historyGram = [
                    result.historgram010 + result.historgram1020 + result.historgram2030 + result.historgram3040 + result.historgram4050,
                    result.historgram5060,
                    result.historgram6070,
                    result.historgram7080,
                    result.historgram8090,
                    result.historgram90Max
                ];
                let percent = (result.totalParticipants *100 /result.totalAssign).toFixed(2);
                this.setState({
                    totalAssign: result.totalAssign,
                    totalComplete: result.totalComplete,
                    totalParticipants:result.totalParticipants,
                    percent:percent==="NaN"?0:percent-0,
                    lowScore: result.lowScore,
                    highScore: result.highScore,
                    avgScore: result.avgScore
                });
                this.getChart(historyGram);
            }else {
                message.error("请选择试卷");
            }
        }else {
            let datum = {
                classRoomId:data.classRoomId,
                type:data.type
            };
            const result = await reqPaperReport(datum);
            let historyGram = [
                result.historgram010 + result.historgram1020 + result.historgram2030 + result.historgram3040 + result.historgram4050,
                result.historgram5060,
                result.historgram6070,
                result.historgram7080,
                result.historgram8090,
                result.historgram90Max
            ];
            let percent = (result.totalParticipants *100 /result.totalAssign).toFixed(2);
            this.setState({
                totalAssign: result.totalAssign,
                totalComplete: result.totalComplete,
                totalParticipants:result.totalParticipants,
                percent:percent==="NaN"?0:percent-0,
                lowScore: result.lowScore,
                highScore: result.highScore,
                avgScore: result.avgScore
            });
            this.getChart(historyGram);
        }
    };

    getPaperList = async (data) => {
        const result = await reqPaperList(data);
        if (result.code === '000000') {
            this.setState({
                paperList: result.data.rows
            })
        } else {
            message.error(result.msg);
        }
    };

    searchList = async () => {
        let data={};
        if(this.state.classRoomId&&this.state.classRoomId!==0){
            data["classRoomId"]=this.state.classRoomId;
        }
        if(this.state.type&&this.state.type!==0){
            data["type"]=this.state.type;
        }
        if(this.state.testPaperId&&this.state.testPaperId!==0){
            data["testPaperId"]=this.state.testPaperId;
        }
        this.getPaperReport(data);
    };

    clearSearch = async() => {
        window.location.reload();
    };

    componentDidMount = async () => {
        sessionStorage.clear();
        this.getClassList({
            page: 1,
            size: 100,
            status:true
        });
        this.setState({
            type:'MOCK'
        });
        this.getPaperList({page: 1, size: 100});
        document.getElementsByClassName("ant-menu-item")[7].click();
        window.scroll(0, 0);
    };

    render() {

        const {classList, totalAssign, totalComplete,totalParticipants, lowScore, highScore, avgScore, paperList,disabled,firstClassId,percent} = this.state;

        return (
            <Layout>
                <Header>Header</Header>
                <Layout>
                    <LeftAd>LeftAd</LeftAd>
                    <Content>
                        <div className='analysis table_right'>
                            <div className='table_search' style={{float:'right'}}>
                                <div className='search_box'>
                                    <Button className='batch_delete clear' onClick={this.clearSearch.bind(this)}>重置</Button>
                                    <Button className='batch_delete search' onClick={this.searchList.bind(this)}>检索</Button>
                                    <div className='search_box'>
                                        <label>试卷名称</label>
                                        <Select id='select_paper' disabled={disabled}
                                                style={{width: 160}}
                                                onChange={this.selectPaper.bind(this)}>
                                            {
                                                paperList&&paperList.map((item, index) => (
                                                    <Option key={index} value={item.id}>{item.name}</Option>
                                                ))
                                            }
                                        </Select>
                                    </div>
                                    <div className='search_box'>
                                        <label>考试类型</label>
                                        <Select id='select_type'
                                                defaultValue={'MOCK'}
                                                style={{width: 160}}
                                                onChange={this.selectType.bind(this)}>
                                            <Option value={'MOCK'}>模拟考试</Option>
                                            <Option value={'FORMAL'}>正式考试</Option>
                                        </Select>
                                    </div>
                                    <label>班级</label>
                                    <Select id='select_class'
                                            style={{width: 160,marginRight:28}}
                                            defaultValue={this.state.firstClassId}
                                            onChange={this.selectClass.bind(this)}>
                                        {
                                            classList&&classList.map((item, index) => (
                                                <Option key={index} value={item.id}>{item.name}</Option>
                                            ))
                                        }
                                    </Select>
                                </div>
                            </div>
                            <div className='any'>
                                <div className='any_left'>
                                    <div className='left_left'>
                                        <span className='top_icon orange'/><span className='top_font'>考试参与率</span>
                                        <div className='top_circle'>
                                            <Progress type="circle" percent={percent} format={percent => `${percent}%`}
                                                      strokeColor={'#fe9a5e'}/>
                                        </div>
                                        <div className='circle_num'>参与考试人数：{totalParticipants}/{totalAssign}人</div>
                                    </div>
                                    <div className='left_right'>
                                        <span className='top_icon cyan'/><span className='top_font'>考试频率</span>
                                        <div className='top_count'>{totalComplete}<span>次</span></div>
                                        <div className='count_num'>{totalAssign}人累计考试{totalComplete}次</div>
                                    </div>
                                    <div className='left_bottom'>
                                        <div><span className='top_icon purple'/><span className='top_font'>分数分析</span>
                                        </div>
                                        <div className='score_left'>
                                            <div>
                                                最低分
                                            </div>
                                            <div>
                                                最高分
                                            </div>
                                            <div>
                                                平均分
                                            </div>
                                        </div>
                                        <div className='score_right'>
                                            <div className='progress'>
                                                <div className='one' style={{width: lowScore + '%'}}/>
                                                <span className='one_num'>{lowScore}分</span>
                                            </div>
                                            <div className='progress'>
                                                <div className='two' style={{width: highScore + '%'}}/>
                                                <span className='two_num'>{highScore}分</span>
                                            </div>
                                            <div className='progress'>
                                                <div className='three' style={{width: avgScore + '%'}}/>
                                                <span className='three_num'>{avgScore}分</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='any_right'>
                                    <span className='top_icon blue'/><span className='top_font'>正确率</span>
                                    <div className='chart' id="main" style={{width: '100%', height: '88%'}}/>
                                    <div className='chart_bot'><span/>共{totalParticipants}人</div>
                                </div>
                            </div>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}
